angular.module("whitelabelApp", ['ngRoute', 'ngResource', 'ngSanitize', 'ui.select', 'rzModule', 'LocalStorageModule', 'angularjs-gauge'])
    .config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider){
        $routeProvider
        .when('/Landing', {
            templateUrl: 'partials/wl.landing.html',
            controller: 'LandingController'
        })
        .when('/Step/:stepId', {
            templateUrl: 'partials/wl.questionset.html',
            controller: 'QuestionSetController'
        })
        .when('/Results', {
            templateUrl: 'partials/wl.results.html',
            controller: 'ResultsController'
        })
        .when('/Refresh', {
            templateUrl: 'partials/wl.results.html',
            controller: 'RefreshController'
        })
        .otherwise({redirectTo : '/Step/1'});
        $locationProvider.html5Mode(false);
    }])
    .directive('loading', function () {
        return {
          restrict: 'E',
          replace:true,
          template: '<div class="loading text-center p-4 m-4"><svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg><br/>LOADING...</div>',
          link: function (scope, element, attr) {
                scope.$watch('loading', function (val) {
                    if (val)
                        scope.loadingStatus = 'true';
                    else
                        scope.loadingStatus = 'false';
                });
          }
        }
    });